import React, { FC, useCallback, useMemo, useState } from "react"
import { ButtonEcomm, Heading } from "@ncs/web-legos/components"
import { IsometricPartSearchBar } from "../IsometricPartSearchBar"
import { container, headerStyle, noDocuments, searchBarContainer, tableContainer } from "./styles"
import { useScreenSizeMatch } from "@ncs/web-legos/util"
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	TableSortLabel,
	Paper,
} from "@material-ui/core"
import { ExplodedViewModal } from "../ExplodedView"
import { ExplodedViewItem } from "@ncs/ncs-api/portal-apps"

type IsometricViewProps = {
	explodedItemsData: ExplodedViewItem[]
	isLoading: boolean
}

export const IsometricView: FC<IsometricViewProps> = ({ explodedItemsData, isLoading }) => {
	const screenIsSM = useScreenSizeMatch("sm")
	const [isModalOpen, setIsModalOpen] = useState(false)
	const [currentExplodedView, setCurrentExplodedView] = useState<ExplodedViewItem | null>(null)

	const [order, setOrder] = useState<"asc" | "desc">("asc")
	const [orderBy, setOrderBy] = useState<keyof ExplodedViewItem>("name")

	const handleRequestSort = (property: keyof ExplodedViewItem) => {
		const isAsc = orderBy === property && order === "asc"
		setOrder(isAsc ? "desc" : "asc")
		setOrderBy(property)
	}

	const sortedRows = useMemo(() => {
		if (!explodedItemsData) return []

		return [...explodedItemsData].sort((a, b) => {
			const valueA = a[orderBy]?.toLowerCase()
			const valueB = b[orderBy]?.toLowerCase()

			if (valueA < valueB) return order === "asc" ? -1 : 1
			if (valueA > valueB) return order === "asc" ? 1 : -1
			return 0
		})
	}, [explodedItemsData, order, orderBy])

	const handleOpenExplodedView = useCallback((item: ExplodedViewItem) => {
		setCurrentExplodedView(item)
		setIsModalOpen(true)
	}, [])

	const handleCloseExplodedView = () => {
		setCurrentExplodedView(null)
		setIsModalOpen(false)
	}

	const mobileMessage = () => (
		<div css={noDocuments}>
			<h4>This feature is only available on desktop.</h4>
			<p>Please use a larger screen to view diagrams and component details.</p>
		</div>
	)

	return (
		<>
			<div>
				<Heading variant="h3" css={headerStyle} bold>
					Isometric Views
				</Heading>

				<div css={container}>
					{/* <div css={searchBarContainer}>
						<IsometricPartSearchBar />
					</div> */}

					{screenIsSM && !isLoading ?
						mobileMessage()
					:	<div css={tableContainer}>
							<TableContainer component={Paper}>
								<Table>
									<TableHead>
										<TableRow>
											<TableCell
												sortDirection={orderBy === "name" ? order : false}
											>
												<TableSortLabel
													active={orderBy === "name"}
													direction={orderBy === "name" ? order : "asc"}
													onClick={() => handleRequestSort("name")}
												>
													Drawing Name
												</TableSortLabel>
											</TableCell>
											<TableCell />
										</TableRow>
									</TableHead>

									<TableBody>
										{sortedRows.map((row) => (
											<TableRow key={row.name} hover>
												<TableCell css={{ textTransform: "uppercase" }}>
													{row.name}
												</TableCell>

												<TableCell>
													<ButtonEcomm
														customTextColor="#0b75e1"
														onClick={() => handleOpenExplodedView(row)}
													>
														View
													</ButtonEcomm>
												</TableCell>
											</TableRow>
										))}
									</TableBody>
								</Table>
							</TableContainer>
						</div>
					}

					{/* ToDo: Implement Pagination for Exploded View List
					<div css={pagination}>
					<PaginationEcomm
						numberOfPages={1}
						fetchPage={() => console.log("Fetch PAGE Testing")}
						currentPage={1}
						isLoading={false}
						withButtons
					/>
				</div> */}
				</div>
			</div>
			<ExplodedViewModal
				onClose={handleCloseExplodedView}
				isOpen={isModalOpen}
				currentExplodedView={currentExplodedView}
			/>
		</>
	)
}
